import React from "react";
import "./about.css";
import Typewriter from "typewriter-effect";
import AboutCard from "./about-card/about-card";

const AboutSection = () => {
  return (
    <div className="about-section">
      <div className="about-cart">
        <div className="about-cart-header">
          <h3
            style={{
              color: "#21a8b9",
              fontWeight: "revert",
              fontFamily: "Mansalva, cursive",
            }}
          >
            Take yourself
          </h3>
          <h1>Adventure Ideas</h1>
        </div>
        <AboutCard />
      </div>
      <div className="about-container">
        <div className="about-info">
          <div className="about-title">
            <h1 className="abtitels" style={{ color: "#21a8b9" }}>
              Who We Are ?
            </h1>
            <h2 className="abtitels">Why Our Company was founded ?</h2>
          </div>
          <div className="about-text">
            <p>
              Our company was founded to develop many products and services in
              the tourism sector, bring them to market and make them
              irresistible and irreplaceable for B2B customers. Rooted in
              innovation, our compnay aims to remedy deficiencies of existing
              products or create entirel new categories of goods and services,
              disrupting entrenched ways of thinking and doing business for
              entire travel and hosting experiences.
            </p>
          </div>
        </div>
        <div className="about-image">
          <img src="/images/5.jpg" alt="About Us" />
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
